export const DataLap = [
    {
        id:1,
        image:"/Images/Maternity/Laproscopy/Laparoscopic Assisted Vaginal Hysterectomy (LAVH) Sabari Hospital Sivaganga (1).webp",
        title:"Laparoscopic Assisted Vaginal Hysterectomy (LAVH)",
        subTitle:"A surgical procedure that removes the uterus and sometimes other reproductive organs through small incisions in the abdomen and vagina.",
    },
    {
        id:2,
        image:"/Images/Maternity/Laproscopy/Laparoscopic Myomectomy Sabari hospital Sivaganga.webp",
        title:"Laparoscopic Myomectomy",
        subTitle:"A minimally invasive surgical procedure to remove uterine fibroids.",
    },
    {
        id:3,
        image:"/Images/Maternity/Laproscopy/Laparoscopic Management of Tubal Ectopic Pregnancy sabari Hospital Sivaganga.webp",
        title:"Laparoscopic Management of Tubal Ectopic Pregnancy",
        subTitle:"A surgical procedure that involves removing the pregnancy and possibly the fallopian tube.",
    },
    {
        id:4,
        image:"/Images/Maternity/Laproscopy/Laparoscopic Ovarian Cystectomy Sabari Hospital Sivaganga.webp",
        title:"Laparoscopic Ovarian Cystectomy",
        subTitle:"A minimally invasive surgical procedure to remove a cyst from one or both ovaries.",
    },
    {
        id: 7,
        image: "/Images/Maternity/Laproscopy/Laparoscopic Appendectomy Sabari Hospital Sivaganga.webp",
        title: "Laparoscopic Appendectomy",
        subTitle:"A minimally invasive surgical procedure to remove the appendix.",
    },
    {
        id: 8,
        image: "/Images/Maternity/Laproscopy/Laparoscopic ovarian drilling (LOD)-Laproscopy-Sivaganaga.webp",
        title: "Laparoscopic ovarian drilling (LOD)",
        subTitle:"A minor surgical procedure that treats fertility issues in women with polycystic ovary syndrome (PCOS). ",
    },
];